<script>
export default {
  data() {
    return {
      switchCost: 'year',
      list: [
        {
          img: require('@assets/images/plan/basic.svg'),
          title: '客戶管理小資方案',
          year: {
            money: '$9,600',
            count: '/年',
            plan: ['提供公版官網', '單店設定', '管理帳號1個', '雲端服務', 'iPet免費網域', '數據分析', '官方Line預約', '優惠券功能'],
          },
          month: {
            money: '$900',
            count: '/月',
            plan: ['提供公版官網', '單店設定', '管理帳號1個', '雲端服務', 'iPet免費網域', '數據分析', '官方Line預約', '優惠券功能'],
          },
          to: '',
        },
        {
          img: require('@assets/images/plan/add-on.svg'),
          title: '線上預約系統方案',
          year: {
            money: '$20,000',
            count: '/年',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          month: {
            money: '$2,400',
            count: '/月',
            plan: [
              '單店設定',
              '簡訊通知100封/月',
              '優惠券功能',
              '管理帳號5個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '分店可升級成專業',
              '官方Line預約',
              '多元付款金流串接（可收費開通）',
              '數據分析',
            ],
          },
          to: 'reserveplan',
        },
        {
          img: require('@assets/images/plan/intermediate.svg'),
          title: '專業店家方案',
          year: {
            money: '$36,000',
            count: '/年',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
            // starPlan: ['專業行銷顧問團隊', '店門形象拍攝', '行銷設計', '多元付款金流串接（進階方案）', '本地商家資訊建置'],
          },
          month: {
            money: '$3,600',
            count: '/月',
            plan: [
              '多店設定',
              '額外新增單間分店$10,000/年（含簡訊300封、管理帳號8個）',
              '簡訊通知300封/月',
              '優惠券功能',
              '管理帳號8個',
              '雲端服務',
              'iPet免費網域',
              '提供專屬網站',
              '商品POS',
              '多元付款金流串接',
              '數據分析',
            ],
            // starPlan: ['專業行銷顧問團隊', '店門形象拍攝', '行銷設計', '多元付款金流串接（進階方案）', '本地商家資訊建置'],
          },
          to: 'marketingplan',
        },
      ],
    }
  },
  methods: {
    handleClick(tab, event) {},
    setPlanMoney(item) {
      if (this.switchCost === 'month') {
        return item.month
      } else {
        return item.year
      }
    },
  },
}
</script>

<template>
  <div :class="$style.sectionPlan">
    <div class="container">
      <div class="row">
        <div class="col-12 align-self-center sectionPlan__rightBox d-flex align-items-center">
          <BaseSectionTitle title="探索最適合您的i寵訂方案" sub-title="Pricing" class="isStyleDecoration text-lg-left text-center islgCenter mx-lg-0 mx-auto" />

          <div class="sectionPlan__body d-lg-flex align-items-center mb-5">
            <p class="sectionPlan__content text-lg-left text-center">
              只要用自己現有的電腦，就能馬上開始輕鬆管理！因應不同規模的寵物美容我們提供2種價格方案。所有方案皆可按月繳費；年繳合約更優惠！從最初的引進系統使用，到以後出現的任何問題，i寵訂都會在這裡為您服務。
            </p>

            <div class="sectionPlan__toggle">
              <el-tabs v-model="switchCost" stretch class="isStyleBase" @tab-click="handleClick">
                <el-tab-pane label="年繳" name="year"></el-tab-pane>
                <el-tab-pane label="月繳" name="month"></el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <!-- <BaseButton :to="{ name: 'contact' }" class="isStylePrimary d-lg-block d-none">
            專人聯繫 <i class="icomoon icon-arrow-button"></i>
          </BaseButton> -->
        </div>
        <div v-for="(item, $index) in list" :key="$index" class="col-lg-4 col-12 sectionPlan__item mt-5">
          <BasePlan :img="item.img" :title="item.title" :money="setPlanMoney(item)" :list="item[switchCost].plan" :star-list="item[switchCost].starPlan" :to="item.to" :is-show-contact="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
.sectionPlan {
  padding-top: 300px;
  padding-bottom: 135px;
  @include max-lg {
    padding-bottom: $section-lg-padding;
  }
  @include max-md {
    padding-top: 190px;
  }
  :global {
    .sectionPlan {
      &__toggle {
        // margin-top: 60px;
      }
      &__content {
        margin-top: 30px;
        padding-left: 20px;
        padding-right: 20px;
        font-size: 14px;
        color: $color-text-2;
        line-height: 1.75;
        @include max-lg {
          margin-bottom: 40px;
        }
      }
      &__body {
        @include max-lg {
          width: 60%;
        }
      }
      &__item {
        @include max-lg {
          margin-top: 110px;
        }
      }
      &__rightBox {
        padding-right: 5.1rem;
        .baseSectionTitle {
          @include max-lg {
            width: 40%;
          }
        }
        .baseSectionTitle__title {
          width: 320px;
          @include max-lg {
            width: auto;
          }
        }
        @include max-lg {
          padding-right: 20px;
        }
      }
    }
    .el-tabs__nav-wrap {
      @include max-lg {
        margin: 0 auto;
      }
    }
  }
}
</style>
